import { ThemeProvider } from '@material-ui/styles'
import { createBrowserHistory } from 'history'
import React, { useEffect } from 'react'
import { Chart } from 'react-chartjs-2'
import 'react-perfect-scrollbar/dist/css/styles.css'
// import { Router } from 'react-router-dom'
import validate from 'validate.js'
import './assets/scss/index.scss'
import validators from './common/validators'
import { chartjs } from './helpers'
// import Routes from './Routes'
import theme from './theme'
import 'chartjs-plugin-datalabels'
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import * as AuthActions from './actions/auth'
import { useActions } from './actions'

import { Dashboard } from './views'

//react cookie
import { CookiesProvider } from 'react-cookie'

//apply layout withour routes
import { Main as MainLayout } from './layouts'
import { Router } from 'react-router'
import Routes from './Routes'


import { useSelector } from 'react-redux'
import getLangcodeFromUrl from './helpers/getLangcodeFromUrl'

const browserHistory = createBrowserHistory()

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
})

Chart.scaleService.updateScaleDefaults('linear', {
  ticks: {
    min: 0
  }
})

validate.validators = {
  ...validate.validators,
  ...validators
}

export const App = () => {
  const authActions = useActions(AuthActions)

  useEffect(() => {
    // dont call auth now
    // authActions.loadUser()
  }, [authActions])



  const langcode = getLangcodeFromUrl(window.location.pathname)
  // const language = useSelector(state.language)

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <Router history={browserHistory}>
          <Routes />
        </Router>
        {/* <MainLayout>
          <Dashboard />
        </MainLayout> */}
      </CookiesProvider>
    </ThemeProvider>
  )
}

export default App
